<script setup>
import { ref, onMounted } from "vue";
//import Conf from '@/Components/MainGlobal.vue';
import SeoMeta from '@/Components/SeoMeta.vue';
import CardBoxModal from "@/Components/CardBoxModal.vue";
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeCheckbox from '@/Components/Checkbox.vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
//import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue';
import BreezeApplicationLogoFull from '@/Components/ApplicationLogoFull.vue';
import BreezeDropdown from '@/Components/Dropdown.vue';
import BreezeDropdownLink from '@/Components/DropdownLink.vue';

import { Icon } from "@iconify/vue";
import Buttons from "@/Components/Buttons.vue";

import BaseButton from "@/Components/BaseButton.vue";
import Footer from '@/Components/Footer.vue';
import { Inertia } from '@inertiajs/inertia';
import BreezeGuestLayout from '@/Layouts/Guest.vue';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';
import { defineComponent } from 'vue';
import { GoogleMap, Marker } from "vue3-google-map";

import '@splidejs/vue-splide/css';

import BaseIcon from "@/Components/BaseIcon.vue";
import MathCaptcha from "@/Components/MathCaptcha.vue";
import {
    mdiMagnify,
    mdiChevronDown,
    mdiAccountOutline,
    mdiCartOutline,
    mdiHeartOutline,
    mdiMenu,
    mdiCloseThick,
    mdiHeadset,
    mdiFacebook,
    mdiInstagram,
    mdiTwitter,
    mdiWhatsapp,
    mdiYoutube,
    mdiTruckFastOutline,
    mdiReload,
    mdiShieldLockOutline,
    mdiTrophyOutline,
    mdiArrowRight,
    mdiShoppingOutline,
    mdiStar,
    mdiArrowExpandAll,
    mdiRepeat,
    mdiChevronRight,
    mdiMinus,
    mdiPlus,
    mdiFlagVariant,
    mdiMoped,
    mdiPercent,
    mdiPhone,
    mdiEmail,
    mdiMapMarker,
    mdiHandshakeOutline,
    mdiAccountGroupOutline,
    mdiShieldStarOutline,
    mdiTruckDeliveryOutline,
    mdiEmailFast,
    mdiSend,
    mdiLoading,
    mdiCheckCircle,
    mdiCloseCircle
} from "@mdi/js";

const props = defineProps({
    canLogin: Boolean,
    canRegister: Boolean,
    laravelVersion: String,
    phpVersion: String,
    appVersion: String,
    contentWelcome: String,
    accessStudents: Boolean,
    accessParents: Boolean,
    object: Object,
    tallas: Array,
    categoryChild: Object,
    categoryParent: Array,
    seo: Object,
    nextCorrelative: String,
    currentDate: String
})



// LRR
//const confGlobal = props.connstantes
/*const confGlobal = ref([])
onMounted(() => {
  let url = '/constante/global';
  axios.get(url).then(function (response) {
      var respuesta = response.data;
      confGlobal.value = respuesta.constantes;
      //console.log(me.constante);
    }).catch(function (error) {
        console.log(error);
  });
});
*/
//console.log( props.connstantes )

// Valid
const isCaptchaValid = ref(false);
const acceptedTerms = ref(false);

const form = ref({
    nombre: '',
    tipo_doc: 'DNI',
    num_doc: '',
    direccion: '',
    telefono: '',
    email: '',
    is_minor: false,
    parent_name: '',
    tipo_bien: 0,
    comprobante: '',
    monto: '',
    descripcion_bien: '',
    tipo_reclamo: 0,
    detalle: '',
    pedido: ''
});
const isModalActive = ref(false);

const stocklabel = ref(false)




// Google maps
const YOUR_GOOGLE_MAPS_API_KEY = ref('AIzaSyCsT0Kr6WvAxXhz60S6i5BOguepFaeoUtg')
const center = ref({ lat: -11.992628, lng: -77.071254 })
const locations = ref([
    { lat: -11.992628, lng: -77.071254 }
])

// Formatos de fecha y tiempo
const formatDate = (datesource) => {
    //var now = new Date().toLocaleDateString()
    if (datesource) {
        var date = new Date(datesource + 'T00:00:00')// <-- Con let no funcionaba <-- Agregar la hora para que no reste un día por la zona horaria del navegador
        //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
        let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
        return result
    }

}

//console.log(props.object)
const formatDateTime = (datetime) => {
    if (datetime) {
        var date = new Date(datetime)// <-- Con let no funcionaba
        //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
        let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + (date.getHours() > 9 ? '' : '0') + date.getHours() + ':' + (date.getMinutes() > 9 ? '' : '0') + date.getMinutes()
        return result
    }

}

const messagesuccess = ref('')
const messagedanger = ref('')
const submitting = ref(false)
const sendMessage = async () => {
    //let ruta = 'eco-orderregistrar' // route(ruta)
    let url = '/ecommerce/complaints';
    submitting.value = true

    await axios.post(url, form.value).then((response) => {
        let resp = response.data
        if (resp.success) {
            messagesuccess.value = resp.message
            // Reset fields but keep message to show success screen
            form.value = { nombre: '', tipo_doc: 'DNI', num_doc: '', direccion: '', telefono: '', email: '', is_minor: false, parent_name: '', tipo_bien: 0, comprobante: '', monto: '', descripcion_bien: '', tipo_reclamo: 0, detalle: '', pedido: '' };
            resultHuman.value = '';
            nValid1.value = Math.ceil(Math.random() * 10);
            nValid2.value = Math.ceil(Math.random() * 10);
            resultvalid.value = parseInt(nValid1.value) + parseInt(nValid2.value);
        } else {
            messagedanger.value = resp.message
        }
        //showAlert('Registro Creado', 'success')
        //listarPostit()
        console.log('Mensaje enviado');
        console.log(response);
    }).catch((error) => {
        console.log(error.response)
        if (error.response && error.response.data) {
            let msg = error.response.data.message
            let poscut = msg.indexOf("(and") // cortar (and 2 more errors)
            let msgerror = msg.substr(0, poscut)
            if (poscut > -1) {
                messagedanger.value = msgerror
            } else {
                messagedanger.value = msg
            }
        } else {
            messagedanger.value = 'Ocurrió un error inesperado. Por favor intente nuevamente.'
        }

    });
    submitting.value = false
}

const resetForm = () => {
    messagesuccess.value = '';
    messagedanger.value = '';
}

</script>

<!-- <script>

import { GoogleMap, Marker } from "vue3-google-map";

const YOUR_GOOGLE_MAPS_API_KEY = "AIzaSyCsT0Kr6WvAxXhz60S6i5BOguepFaeoUtg";

export default {
  name: "App",
  components: { GoogleMap, Marker },
  data() {
    const center = { lat: 40.689247, lng: -111.044502 };
    return { center, YOUR_GOOGLE_MAPS_API_KEY };
  },
};

</script> -->






<!-- <script>
import { Splide, SplideSlide } from '@splidejs/vue-splide';


export default defineComponent({
    name: 'ThumbnailsExample',

    components: {
        Splide,
        SplideSlide,
    },

    setup() {
        
        const slides = generateSlides();


        onMounted(() => {
            const thumbsSplide = thumbs.value?.splide;

            if (thumbsSplide) {
                main.value?.sync(thumbsSplide);
            }
        });

        return {
            slides,
            main,
            thumbs,
            mainOptions,
            thumbsOptions,
        }
    },
});

</script> -->




<template>
    <SeoMeta />
    <!-- Head con categorías -->
    <BreezeGuestLayout :categoryChild="categoryChild" :categoryParent="categoryParent">




        <!-- START AREA DE TITULO -->
        <!-- START AREA DE TITULO -->
        <!-- START AREA DE TITULO -->

        <section>
            <div class="w-full h-[250px ] relative">
                <div aria-hidden="true" class="px-4 sm:px-6 lg:px-8 py-10 lg:py-20 inset-0 absolute bg-[url('/img/empresa/reclamaciones/header.jpg')] bg-no-repeat bg-center bg-cover">
                </div>
                <div class="px-4 sm:px-6 lg:px-8 py-10 lg:py-20 absolute inset-0 bg-black bg-opacity-50">
                </div>
                <div class="mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-20">
                    <div class="relative flex flex-col lg:flex-row lg:justify-between items-center">
                        <div>
                            <h1 class="text-2xl lg:text-3xl text-white">Quejas o Reclamos</h1>
                        </div>
                        <div>
                            <p class="text-xs lg:text-sm text-white font-semibold">Inicio</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- END AREA DE TITULO -->
        <!-- END AREA DE TITULO -->
        <!-- END AREA DE TITULO -->




        <!-- START INFO EMPRESA -->
        <!-- START INFO EMPRESA -->
        <!-- START INFO EMPRESA -->

        <section>
            <div class="mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
                <div class="flex flex-row justify-center">
                    <div class="lg:basis-3/4">
                        <div class="mb-10">
                            <h1 class="text-2xl lg:text-3xl font-bold mb-4">Libro de Reclamaciones</h1>
                        </div>
                        <div class="mb-4">
                            <p class="text-sm text-gray-900 font-bold">Conforme al Código de Protección y Defensa del Consumidor</p>
                        </div>
                        <div class="flex justify-between mb-4">
                            <div>
                                Hoja de Reclamación: <span class="font-semibold">{{ nextCorrelative || 'Generando...' }}</span>
                            </div>
                            <div>Fecha: <span class="font-semibold">{{ currentDate }}</span></div>
                        </div>
                        <hr class="my-6">
                        <div class="flex flex-col lg:items-center justify-center lg:space-x-">
                            <div>
                                <form @submit.prevent="sendMessage" v-if="!messagesuccess" class="w-full">
                                    <section class="mb-4">
                                        <div class="pb-2 mb-4">
                                            <h2 class="text-lg font-semibold ">1. Identificación del Consumidor Reclamante</h2>
                                        </div>

                                        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                            <div class="md:col-span-2">
                                                <label for="nombre" class="block text-sm font-medium ">Nombre Completo / Razón Social</label>
                                                <input type="text" id="nombre" name="nombre" v-model="form.nombre" class="mt-1 block w-full rounded-md shadow-sm  sm:text-sm" placeholder="Ej. Juan Pérez" required>
                                            </div>

                                            <div>
                                                <label for="tipo_doc" class="block text-sm font-medium ">Tipo de Documento</label>
                                                <select id="tipo_doc" name="tipo_doc" v-model="form.tipo_doc" class="mt-1 block w-full rounded-md shadow-sm  sm:text-sm">
                                                    <option>DNI</option>
                                                    <option>RUC</option>
                                                    <option>Carné Extranjería</option>
                                                    <option>Pasaporte</option>
                                                </select>
                                            </div>

                                            <div>
                                                <label for="num_doc" class="block text-sm font-medium ">Número de Documento</label>
                                                <input type="text" id="num_doc" name="num_doc" v-model="form.num_doc" class="mt-1 block w-full rounded-md shadow-sm  sm:text-sm" required>
                                            </div>

                                            <div class="md:col-span-2">
                                                <label for="direccion" class="block text-sm font-medium ">Domicilio</label>
                                                <input type="text" id="direccion" name="direccion" v-model="form.direccion" class="mt-1 block w-full rounded-md shadow-sm sm:text-sm" placeholder="Av. Principal 123, Distrito, Ciudad" required>
                                            </div>

                                            <div>
                                                <label for="telefono" class="block text-sm font-medium ">Teléfono / Celular</label>
                                                <input type="tel" id="telefono" name="telefono" v-model="form.telefono" class="mt-1 block w-full rounded-md shadow-sm sm:text-sm" required>
                                            </div>

                                            <div>
                                                <label for="email" class="block text-sm font-medium ">Correo Electrónico</label>
                                                <input type="email" id="email" name="email" v-model="form.email" class="mt-1 block w-full rounded-md  shadow-sm  sm:text-sm" required>
                                            </div>

                                            <div class="md:col-span-2 bg-gray-50 p-3 rounded-md border text-sm">
                                                <label class="flex items-center space-x-2">
                                                    <input type="checkbox" v-model="form.is_minor" class="rounded">
                                                    <span>Soy menor de edad (Activar para ingresar datos del apoderado)</span>
                                                </label>
                                                <div v-if="form.is_minor" class="mt-3">
                                                    <label class="block text-xs font-medium text-gray-500">Nombre del Padre, Madre o Apoderado: <span class="text-red-500">*</span></label>
                                                    <input type="text" v-model="form.parent_name" :required="form.is_minor" class="mt-1 block w-full rounded-md sm:text-sm">
                                                </div>
                                            </div>
                                        </div>
                                    </section>

                                    <hr class="border-gray-200 my-6">

                                    <section>
                                        <div class="pb-2 mb-4">
                                            <h2 class="text-lg font-semibold ">2. Identificación del Bien Adquirido</h2>
                                        </div>

                                        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                                            <div>
                                                <span class="block text-sm font-medium  mb-2">Tipo de Bien:</span>
                                                <div class="flex space-x-6">
                                                    <label class="inline-flex items-center">
                                                        <input type="radio" name="tipo_bien" value="0" v-model="form.tipo_bien">
                                                        <span class="ml-2 ">Producto</span>
                                                    </label>
                                                    <label class="inline-flex items-center">
                                                        <input type="radio" name="tipo_bien" value="1" v-model="form.tipo_bien">
                                                        <span class="ml-2 ">Servicio</span>
                                                    </label>
                                                </div>
                                            </div>
                                            <div>
                                                <label for="comprobante" class="block text-sm font-medium ">Numero de Factura o Boleta</label>
                                                <input type="text" id="comprobante" name="comprobante" v-model="form.comprobante" class="mt-1 block w-full rounded-md" required>
                                            </div>
                                            <div>
                                                <label for="monto" class="block text-sm font-medium ">Costo del bien (S/.)</label>
                                                <input type="number" step="0.01" id="monto" name="monto" v-model="form.monto" class="mt-1 block w-full rounded-md" required>
                                            </div>

                                            <div class="md:col-span-3">
                                                <label for="descripcion_bien" class="block text-sm font-medium ">Descripción del Producto</label>
                                                <textarea id="descripcion_bien" name="descripcion_bien" v-model="form.descripcion_bien" rows="2" class="mt-1 block w-full rounded-md sm:text-sm" placeholder="Ej. Zapatillas Modelo X, Talla 42..."></textarea>
                                            </div>
                                        </div>
                                    </section>

                                    <hr class="border-gray-200 my-6">

                                    <section>
                                        <div class="pb-2 mb-4">
                                            <h2 class="text-lg font-semibold ">3. Detalle de la Reclamación y Pedido</h2>
                                        </div>

                                        <div class="space-y-6">
                                            <div class="bg-sky-100 p-4 rounded-md border border-sky-200">
                                                <span class="block text-sm font-bold  mb-2">Seleccione el tipo:</span>
                                                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                    <label class="flex items-start">
                                                        <input type="radio" name="tipo_reclamo" value="0" v-model="form.tipo_reclamo" class="mt-1 ">
                                                        <div class="ml-3">
                                                            <span class="block text-sm font-medium text-gray-900">Reclamo</span>
                                                            <span class="block text-xs text-gray-500">Disconformidad relacionada a los productos o servicios.</span>
                                                        </div>
                                                    </label>
                                                    <label class="flex items-start">
                                                        <input type="radio" name="tipo_reclamo" value="1" v-model="form.tipo_reclamo" class="mt-1 ">
                                                        <div class="ml-3">
                                                            <span class="block text-sm font-medium text-gray-900">Queja</span>
                                                            <span class="block text-xs text-gray-500">Disconformidad no relacionada a los productos o servicios; o malestar o descontento respecto a la atención al público.</span>
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>

                                            <div>
                                                <label for="detalle" class="block text-sm font-medium ">Detalle de la Reclamación o Queja</label>
                                                <textarea id="detalle" name="detalle" v-model="form.detalle" rows="4" class="mt-1 block w-full rounded-md shadow-sm sm:text-sm" required></textarea>
                                            </div>

                                            <div>
                                                <label for="pedido" class="block text-sm font-medium ">Pedido del Consumidor</label>
                                                <textarea id="pedido" name="pedido" v-model="form.pedido" rows="3" class="mt-1 block w-full rounded-md shadow-sm f sm:text-sm" placeholder="Ej. Solicito el cambio del producto o devolución del dinero..." required></textarea>
                                            </div>
                                        </div>
                                    </section>
                                    <section class="space-y-3 pt-6">
                                        <div class="col-span-12">
                                            <MathCaptcha v-if="!messagesuccess" v-model="isCaptchaValid" />
                                        </div>
                                        <div v-if="messagedanger && !messagesuccess" class=" bg-red-50 border-red-600 text-sm px-3 py-2 border justify-left rounded-md flex items-center space-x-3">
                                            <BaseIcon :path="mdiCloseCircle" :size="24" w="w-4" h="h-4" class="text-red-600"></BaseIcon><span class=" text-red-600">{{ messagedanger }}</span>
                                        </div>
                                    </section>
                                    <section class="space-y-3 pt-6">
                                        <!-- <label class="flex items-center">
                                            <input type="checkbox" required class="rounded ">
                                            <span class="ml-2 text-sm text-gray-600">Declaro que los datos consignados son verdaderos y acepto la <a href="#" class="underline">Política de Privacidad</a>.</span>
                                        </label> -->
                                        <label class="flex items-center">
                                            <input type="checkbox" v-model="acceptedTerms" required class="rounded">
                                            <span class="ml-2 text-sm text-gray-600">Acepto que la respuesta a mi reclamo o queja sea enviada a mi correo electrónico proporcionado.</span>
                                        </label>
                                    </section>
                                    <div class="pt-6 text-center flex justify-center">
                                        <!-- <button v-if="!messagesuccess" type="submit" class="btn-lg btn-color btn-ico">
                                            <BaseIcon :path="mdiSend" :size="32" class="mr-3" w="w-4" h="h-4"></BaseIcon> Enviar Reclamación
                                        </button> -->
                                        <!-- Buttons -->
                                        <div class="col-span-12">
                                             <button v-if="!messagesuccess" type="submit" class="btn btn-color px-8 space-x-3 flex items-center" :disabled="(submitting || !isCaptchaValid || !acceptedTerms)" :class="(!isCaptchaValid || !acceptedTerms ? 'cursor-none opacity-50 hover:!bg-sky-500 focus-!ring-0' : '')">
                                        <BaseIcon :path="(submitting ? mdiLoading : mdiSend)" :size="24" w="w-4" h="h-4" class="text-white" :class="(submitting ?'animate-spin': '')"></BaseIcon>
                                        <span>Enviar Mensaje</span></button>
                                        </div>
                                    </div>
                                </form>
                                <div v-else class="flex flex-col items-center justify-center py-16 px-4 sm:px-10 bg-white rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.08)] border border-gray-100 max-w-3xl mx-auto w-full my-8">
                                    <div class="rounded-full bg-green-50 p-5 mb-6">
                                        <Icon icon="tabler:circle-check-filled" class="w-20 h-20 text-green-500 drop-shadow-sm" />
                                    </div>
                                    <h2 class="text-lg lg:text-xl font-extrabold text-gray-800 mb-4 text-center">¡Formulario Registrado con Éxito!</h2>
                                    <p class="text-md lg:text-base text-gray-600 text-center mb-8 leading-relaxed font-medium" v-html="messagesuccess"></p>
                                    
                                    <div class="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
                                        <!-- <Buttons @click="resetForm" color="primary" class="w-full sm:w-auto justify-center px-8 py-3.5 shadow-md">
                                            <Icon icon="tabler:plus" class="w-6 h-6 mr-2" />
                                            <span>Registrar un Nuevo Reclamo</span>
                                        </Buttons> -->
                                        <Buttons as="a" href="/" color="primary" class="w-full sm:w-auto justify-center px-8 py-3.5">
                                            <Icon icon="tabler:home" class="w-6 h-6 mr-2" />
                                            <span>Volver al Inicio</span>
                                        </Buttons>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section>


        <!-- END INFO EMPRESA -->
        <!-- END INFO EMPRESA -->
        <!-- END INFO EMPRESA -->

        <!-- <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div class="grid grid-cols-2">
                <div class="col-span-1">
                    <Splide id="main-carousel" :options="{
                        type: 'fade',
                        rewind: true,
                        pagination: false,
                        arrows: false,
                    }">
                        <SplideSlide>
                            <img src="/img/productos/independiente/01.jpg" alt="Sample 1">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/02.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/03.jpg" alt="Sample 2">
                        </SplideSlide>
                    </Splide>

                    <Splide :options="{
                        fixedWidth: 100,
                        fixedHeight: 60,
                        gap: 10,
                        rewind: true,
                        pagination: false,
                        cover: true,
                        focus: 'center',
                        breakpoints: {
                            600: {
                                fixedWidth: 60,
                                fixedHeight: 44,
                            },
                        },
                    }">
                        <SplideSlide>
                            <img src="/img/productos/independiente/01.jpg" alt="Sample 1">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/02.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/03.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/04.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/05.jpg" alt="Sample 2">
                        </SplideSlide>
                    </Splide>
                </div>
            </div>

        </div> -->


    </BreezeGuestLayout>
</template>

<style scoped>
.splide__slide img {

    object-fit: cover;
}
</style>
